import * as actInvPO from 'actions/inventory/purchaseOrder';
import { put, call, takeLatest, takeEvery } from 'redux-saga/effects';
import * as act from 'actions';
import * as apiOutlets from 'api/outlets';
import * as apiProfile from 'api/profile';
import * as apiItems from 'api/items';
import * as apiIngredients from 'api/ingredients';
import * as actNotif from 'actions/notifications';
import * as apiInvPO from 'api/inventory/purchaseOrder';
import * as apiInvSup from 'api/inventory/suppliers';
import * as apiIngInv from 'api/ingredientInventory/purchaseOrder';
import * as apiGetFilteredDate from 'api/get-filtered-date';
import * as apiUpdateFilteredDate from 'api/update-filtered-date';
import * as apiCurrentInventory from 'api/currentInventoryDropdown';
import { rupiah } from 'utils/formatter';
import _ from 'lodash';
import { delay } from 'redux-saga';
import {
  INVENTORY_PURCHASE_ORDER_PAGE_REQUEST,
  INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS,
  INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL,
  INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API,
  INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM,
  INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM,
  INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM,
  INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER,
  INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM,
  INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT,
  INVENTORY_PURCHASE_ORDER_ON_SUCCESS_IMPORT,
  INVENTORY_PURCHASE_ORDER_EXPORT_FAILED,
} from 'actions/inventory/purchaseOrder/constants';
import {
  initialize,
  change,
  arrayPush,
  reset,
  arrayRemoveAll,
} from 'redux-form';
import moment from 'moment';
import * as clevertapInventoryPurchaseOrders from 'clevertap/inventory/purchaseOrders';
import { subscriptionStatus } from 'actions/inventory/ingredientSubscription';

import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS,
} from 'actions/inventory/constants';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';

export function* emptyForm() {
  yield put(reset('purchaseOrder'));
}

export function* onchangeOutletForm() {
  yield put(change('purchaseOrder', 'itemPurchase', []));
}
export function* purchaseOrderRequest(request) {
  const {
    payload: { params, previousPurchaseOrders, namespace },
  } = request;
  try {
    yield put(act.showProgressBar());
    let resPurchaseOrders;
    if (namespace === NAMESPACE_ITEMS) {
      resPurchaseOrders = yield call(apiInvPO.getSearchPurchaseOrders, params);
    } else {
      resPurchaseOrders = yield call(apiIngInv.getSearchPurchaseOrders, params);
    }
    const purchaseOrders = previousPurchaseOrders.concat([]);
    resPurchaseOrders.data.results.forEach(po => {
      const lastPO = purchaseOrders[purchaseOrders.length - 1];
      if (
        purchaseOrders.length === 0 ||
        !moment(po.created_at).isSame(moment(lastPO.created_at), 'days')
      ) {
        purchaseOrders.push({
          created_at: po.created_at,
          isdaterow: true,
        });
      }
      purchaseOrders.push({ ...po, isdaterow: false });
    });
    const totalPage = resPurchaseOrders.data.total_pages;
    const currentPage = params.page;
    yield put(actInvPO.setPurchaseOrders(purchaseOrders));
    yield put(actInvPO.setTotalPage(totalPage));
    yield put(actInvPO.setCurrentPage(currentPage));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(showPageLoadingSpinner(false));
  }
}

export function* pageRequest() {
  // reset...
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(showPageLoadingSpinner(true));
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield put(actInvPO.closeRightColumn());
  yield put(act.showProgressBar());
  try {
    const response = yield call(apiOutlets.outlets);
    yield put(actInvPO.setOutlets(response.data));

    const resProfile = yield call(apiProfile.getProfile);

    const resGetFilteredDate = yield call(apiGetFilteredDate.getFilteredDate);
    const startDate = moment(resGetFilteredDate.data.start_date);
    const endDate = moment(resGetFilteredDate.data.end_date);

    const resCurrentInventoryDropdown = yield call(
      apiCurrentInventory.getCurrentInventoryDropdown
    );
    const currentInventoryDropdown =
      resCurrentInventoryDropdown.data.current_inventory_dropdown;

    yield put(
      actInvPO.purchaseOrderRequest(
        currentInventoryDropdown,
        {
          page: 1,
          start: moment(resGetFilteredDate.data.start_date).format('D/M/YYYY'),
          end: moment(resGetFilteredDate.data.end_date).format('D/M/YYYY'),
          status: '',
        },
        []
      )
    );

    yield put(
      initialize('search', {
        outletIds: resProfile.data.outlet_id,
        date: { startDate, endDate },
        namespace: currentInventoryDropdown,
      })
    );
    yield put(actInvPO.setSelectedOutlet(resProfile.data.outlet_id));
    clevertapInventoryPurchaseOrders.inventoryPOStart({
      outletIds: resProfile.data.outlet_id,
      startDate,
      endDate,
      namespace: currentInventoryDropdown,
    });

    const resSuppliers = yield call(apiInvSup.getSuppliers, {
      with_default: true,
    });
    yield put(actInvPO.setSuppliers(resSuppliers.data));

    yield put(subscriptionStatus());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onChangeOutletIds(request) {
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { outletIds, params, namespace },
  } = request;

  yield put(actInvPO.setPurchaseOrders([]));
  yield put(actInvPO.closeRightColumn());
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield put(act.showProgressBar());
  yield call(emptyForm);
  try {
    yield call(apiOutlets.patchLogin, { id: outletIds });
    yield put(change('search', 'outletIds', outletIds));
    yield put(actInvPO.setSelectedOutlet(outletIds));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }

  yield put(actInvPO.purchaseOrderRequest(namespace, params, []));
}

export function* onChangeDate(request) {
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { startDate, endDate, params, namespace },
  } = request;

  yield put(actInvPO.setPurchaseOrders([]));
  yield put(actInvPO.closeRightColumn());
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield put(act.showProgressBar());
  yield call(emptyForm);
  yield put(change('search', 'date', { startDate, endDate }));
  try {
    yield call(apiUpdateFilteredDate.updateFilteredDate, {
      from: startDate.toString(),
      to: endDate.toString(),
    });
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(actInvPO.purchaseOrderRequest(namespace, params, []));
}

export function* onChangeNamespace(request) {
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { namespace, params },
  } = request;

  yield put(actInvPO.setPurchaseOrders([]));
  yield put(actInvPO.closeRightColumn());
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield put(actInvPO.onCancelModalAddItem());
  yield put(act.showProgressBar());
  yield call(emptyForm);
  yield put(change('search', 'namespace', namespace));
  try {
    yield call(apiCurrentInventory.putCurrentInventoryDropdown, {
      current_inventory_dropdown: namespace,
    });
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
  yield put(actInvPO.purchaseOrderRequest(namespace, params, []));
}

export function* onChangeStatus(request) {
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(showPageLoadingSpinner(true));
  // currently we don't use 'status' from request
  const {
    payload: { namespace, params },
  } = request;
  // delay to prevent too fast ajax
  yield call(delay, 300);
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(actInvPO.closeRightColumn());
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield put(actInvPO.purchaseOrderRequest(namespace, params, []));
}

export function* onChangeKeyword(request) {
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { namespace, params },
  } = request;
  yield put(actInvPO.setPurchaseOrders([]));
  yield put(actInvPO.closeRightColumn());
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield put(actInvPO.purchaseOrderRequest(namespace, params, []));
}

export function* exportPurchaseOrder(request) {
  yield put(act.showLoadingSpinner(true));
  try {
    yield put(actInvPO.startExportPurchaseOrder());
    const {
      payload: {
        params: { namespace, ...restParams },
      },
    } = request;
    if (namespace === NAMESPACE_ITEMS) {
      const { data } = yield call(apiInvPO.getExportPurchaseOrder, restParams);
      yield put(actInvPO.setIdAsyncJob(data.async_job_id));
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      const { data } = yield call(apiIngInv.getExportPurchaseOrder, restParams);
      yield put(actInvPO.setIdAsyncJob(data.async_job_id));
    }
  } catch (error) {
    yield put(actInvPO.doneExportPurchaseOrder());
    yield put(act.showLoadingSpinner(false));
    yield put(actNotif.error(error.message));
  }
}

export function* exportPurchaseOrderFailed(error) {
  yield put(act.showLoadingSpinner(false));
  yield put(actNotif.error(error.message));
}

export function* onClickRow(request) {
  const {
    payload: { namespace, purchaseOrder },
  } = request;
  try {
    yield put(act.showProgressBar());
    let resPO;
    if (namespace === NAMESPACE_ITEMS) {
      resPO = yield call(apiInvPO.getPurchaseOrderById, purchaseOrder.id);
      yield put(actInvPO.setPurchaseOrderDetail(resPO.data));
    } else {
      resPO = yield call(apiIngInv.getPurchaseOrderById, purchaseOrder.id);
      const newIngHistoryDetails = resPO.data.ingredient_history_details.sort(
        (a, b) => {
          if (a.ingredient_name !== b.ingredient_name) {
            if (a.ingredient_name < b.ingredient_name) {
              return -1;
            }
            return 1;
          }
          return 0;
        }
      );
      const sortedPO = {
        ...resPO.data,
        ingredient_history_details: newIngHistoryDetails,
      };
      yield put(actInvPO.setPurchaseOrderDetail(sortedPO));
    }
    clevertapInventoryPurchaseOrders.inventoryPOSelect({
      purchaseOrder: resPO.data,
    });
    yield put(actInvPO.openRightColumnAsDetail());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickDone() {
  yield put(actInvPO.closeRightColumn());
  yield put(actInvPO.setPurchaseOrderDetail(null));
}

export function* onClickCancel() {
  yield put(actInvPO.setPurchaseOrderDetail(null));
  yield call(emptyForm);
  yield put(actInvPO.closeRightColumn());
}

export function* onClickPrint(request) {
  const {
    payload: { purchaseOrder },
  } = request;
  let pdfRes;
  if (purchaseOrder.ingredient_history_details) {
    pdfRes = yield call(apiIngInv.printPurchaseOrder, purchaseOrder.id);
  } else {
    pdfRes = yield call(apiInvPO.printPurchaseOrder, purchaseOrder.id);
  }
  window.open(pdfRes.data);
}

export function* onClickResendEmail(request) {
  const {
    payload: { purchaseOrder },
  } = request;
  try {
    yield put(act.showProgressBar());
    let resResendEmail;
    if (purchaseOrder.ingredient_history_details) {
      resResendEmail = yield call(
        apiIngInv.resendEmailPurchaseOrder,
        purchaseOrder.id
      );
    } else {
      resResendEmail = yield call(
        apiInvPO.resendEmailPurchaseOrder,
        purchaseOrder.id
      );
    }
    yield put(actNotif.success(resResendEmail.data.message));
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onClickCreatePO(request) {
  yield put(actInvPO.setPurchaseOrderDetail(null));
  const { outletIds } = request.payload;
  try {
    yield put(act.showProgressBar());
    const resSuppliers = yield call(apiInvSup.getSuppliers, {
      with_default: true,
    });
    yield put(actInvPO.setSuppliers(resSuppliers.data));
    yield put(
      initialize('purchaseOrder', {
        outlet: outletIds[0],
        supplierName: '0',
        note: '',
        itemPurchase: [],
      })
    );
    yield put(actInvPO.openRightColumnAsForm());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* updatePurchaseOrder(request) {
  const {
    payload: { purchaseOrder, status },
  } = request;
  try {
    yield put(act.showProgressBar());
    purchaseOrder.status = status;
    let updateResult;
    if (purchaseOrder.ingredient_history_details) {
      updateResult = yield call(apiIngInv.updateDataPO, purchaseOrder.id, {
        ingredient_purchase_order: purchaseOrder,
      });
    } else {
      updateResult = yield call(apiInvPO.updateDataPO, purchaseOrder.id, {
        purchase_order: purchaseOrder,
      });
    }
    if (status === 'Fulfilled') {
      if (updateResult.data.error) {
        yield put(actNotif.error(updateResult.data.error));
      } else {
        yield put(
          actNotif.success('Purchase order has been mark as fulfilled')
        );
      }
    } else if (status === 'Cancelled') {
      yield put(actNotif.success('Purchase order has been mark as cancelled'));
    }
    clevertapInventoryPurchaseOrders.inventoryPOUpdateStatus({
      purchaseOrder,
      status,
    });
    yield put(actInvPO.pageRequest());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* getItemsfromAPI(request) {
  const {
    payload: {
      params: { previousItems, first, namespace, ...restParams },
    },
  } = request;
  yield put(actInvPO.isLoadingItem(true));
  yield put(actInvPO.setAddedItem(null));
  yield put(actInvPO.setIsItemAdded(false));
  if (restParams.keyword) {
    yield call(delay, 300);
  }
  try {
    let resItems = null;
    if (namespace === NAMESPACE_ITEMS) {
      restParams.page = first ? restParams.page - 1 : restParams.page;
      restParams.searchCategoryName = false;
      resItems = yield call(apiItems.getItemsV1, restParams);

      const items = {
        results: resItems.data.items,
        total_pages: 9999,
        total_counts: 0,
      };

      if (items.results) {
        items.results.forEach(item => {
          if (!item.is_recipe) {
            item.is_recipe = false;
          }
          item.item_variants = item.item_variants.filter(iv => iv.track_stock);
          item.item_variants.forEach(iv => {
            if (!iv.in_stock) {
              iv.in_stock = 0;
            }
          });
        });
        items.results = items.results.filter(item => {
          return item.item_variants && item.item_variants.length > 0;
        });
      } else {
        items.results = [];
      }

      if (first) {
        yield put(actInvPO.setFirstItems(items));
      }

      if (restParams.page > 0) {
        if (items.results.length === 0) {
          items.total_pages = restParams.page - 1;
          items.currentPage = restParams.page - 1;
        } else {
          items.currentPage = restParams.page;
        }
        items.results = previousItems.concat(items.results);
      } else {
        items.currentPage = 0;
      }

      yield put(actInvPO.setDataSearch(items));
    } else {
      resItems = yield call(apiIngredients.getAll, restParams);

      const items = {
        results: resItems.data.results,
        total_pages: 9999,
        total_counts: 0,
      };

      if (first) {
        yield put(actInvPO.setFirstItems(items));
      }

      if (restParams.page > 1) {
        if (items.results.length === 0) {
          items.total_pages = restParams.page - 1;
          items.currentPage = restParams.page - 1;
        } else {
          items.currentPage = restParams.page;
        }
        items.results = previousItems.concat(items.results);
      } else {
        items.currentPage = 1;
      }

      yield put(actInvPO.setDataSearch(items));
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actInvPO.isLoadingItem(false));
  }
}

function ignoreRp(value, namespace) {
  if (namespace === NAMESPACE_ITEMS) {
    return value.replace(/[^\d]/g, '');
  }
  return value;
}

export function* setModalItemForm(request) {
  const {
    payload: { namespace, data, itemPurchase },
  } = request;
  let itemPurchaseMap = [];
  let isItemExist = false;
  let itemVars = [];
  if (namespace === NAMESPACE_ITEMS) {
    itemPurchaseMap = _.mapKeys(itemPurchase, value => {
      return value.item_id.toString();
    });
    if (itemPurchaseMap[data.id]) {
      isItemExist = true;
    } else {
      itemVars = data.item_variants.map(iv => {
        const unitcost = itemPurchaseMap[iv.id]
          ? itemPurchaseMap[iv.id].unitcost
          : '0';
        const total = 0 * unitcost;
        return {
          item_var_name: iv.name,
          item_var_id: iv.id,
          instock: iv.in_stock,
          order: '0',
          unitcost,
          item_name: data.name,
          item_id: data.id,
          is_item: data.item_variants.length === 1 && !iv.name,
          total: rupiah(total),
        };
      });
    }
  } else {
    itemPurchaseMap = _.mapKeys(itemPurchase, value => {
      return value.item_id.toString();
    });
    if (itemPurchaseMap[data.id]) {
      isItemExist = true;
    }
    itemVars = [
      {
        item_var_name: data.unit_name,
        item_var_id: data.unit_id,
        instock: data.in_stock,
        order: '0',
        unitcost: '0',
        item_name: data.name,
        item_id: data.id,
        is_item: false,
        total: rupiah(0),
        category_name: data.category_name,
        category_id: data.ingredient_category_id,
      },
    ];
  }
  yield put(
    initialize('addItemPurchase', {
      header: '',
      items: !isItemExist ? itemVars : [],
    })
  );
  yield put(actInvPO.setAddedItem(!isItemExist ? data : null));
  yield put(actInvPO.setIsItemAdded(isItemExist));
}

export function* addItemToForm(request) {
  const {
    itemVariantValue: { items },
    formPO,
    namespace,
  } = request.payload;
  // grouping items
  let itemIdsOrderCounter = 0;
  const itemIdsOrder = {};
  // order itemIds based of
  formPO.forEach(PO => {
    if (!itemIdsOrder[PO.item_id]) {
      itemIdsOrder[PO.item_id] = ++itemIdsOrderCounter;
    }
  });
  items.forEach(item => {
    if (!itemIdsOrder[item.item_id]) {
      itemIdsOrder[item.item_id] = ++itemIdsOrderCounter;
    }
  });

  // data merging
  const newPOObjectvarianItemList = {};
  if (namespace === NAMESPACE_INGREDIENTS) {
    formPO.forEach(PO => {
      newPOObjectvarianItemList[PO.item_id] = PO;
    });

    items.forEach(item => {
      newPOObjectvarianItemList[item.item_id] = item;
      newPOObjectvarianItemList[item.item_id].unitcost =
        `${item.unitcost}` === '' ? '0' : ignoreRp(item.unitcost, namespace);
      newPOObjectvarianItemList[item.item_id].order =
        `${item.order}` === '' ? '0' : ignoreRp(item.order, namespace);
    });
  } else if (namespace === NAMESPACE_ITEMS) {
    formPO.forEach(PO => {
      newPOObjectvarianItemList[PO.item_var_id] = PO;
    });

    items.forEach(item => {
      newPOObjectvarianItemList[item.item_var_id] = item;
      newPOObjectvarianItemList[item.item_var_id].unitcost =
        `${item.unitcost}` === '' ? '0' : ignoreRp(item.unitcost, namespace);
      newPOObjectvarianItemList[item.item_var_id].order =
        `${item.order}` === '' ? '0' : ignoreRp(item.order, namespace);
    });
  }

  // convert to array
  let newItemPurchase = [];

  Object.keys(newPOObjectvarianItemList).forEach(key => {
    newItemPurchase.push(newPOObjectvarianItemList[key]);
  });
  newItemPurchase = newItemPurchase.sort((a, b) => {
    if (itemIdsOrder[a.item_id] !== itemIdsOrder[b.item_id]) {
      if (itemIdsOrder[a.item_id] < itemIdsOrder[b.item_id]) {
        return -1;
      }
      return 1;
    }
    if (a.position !== b.position) {
      if (a.position < b.position) {
        return -1;
      }
      return 1;
    }
    return 0;
  });

  yield put(arrayRemoveAll('purchaseOrder', 'itemPurchase'));
  for (let i = 0; i < newItemPurchase.length; i++) {
    yield put(arrayPush('purchaseOrder', 'itemPurchase', newItemPurchase[i]));
  }
  yield put(actInvPO.onCancelModalAddItem());
}
export function* onCancelModalAddItem() {
  yield put(actInvPO.closeModalItemPurchase());
  yield put(
    initialize('addItemPurchase', {
      items: [],
    })
  );
  yield put(actInvPO.setDataSearch([]));
  yield put(actInvPO.setIsItemAdded(false));
  yield put(actInvPO.setAddedItem(null));
  yield put(actInvPO.setFirstItems([]));
}

function populateDataPO(namespace, reqPayload, data) {
  if (namespace === NAMESPACE_ITEMS) {
    reqPayload = {
      purchase_order: {
        outlet_id: data.outlet,
        note: data.note,
        status: 'Created',
        supplier_id: data.supplierName === '' ? 0 : parseInt(data.supplierName),
        total: 0,
        history_details: [],
        history_details_attributes: [],
      },
    };
    data.itemPurchase.forEach(item => {
      // Front End must process the order and unitcost using parsefloat or parseint since the backend return the value as a string
      const order = parseInt(item.order);
      const unitCost = parseInt(item.unitcost);
      reqPayload.purchase_order.total += order * unitCost;
      if (order > 0) {
        const itemPO = {
          beginning_stock: item.instock,
          end_stock: item.instock + order,
          item_id: item.item_id,
          item_name: item.item_name,
          item_variant_id: item.item_var_id,
          item_variant_name: item.item_var_name,
          price: unitCost,
          quantity: item.order,
        };
        reqPayload.purchase_order.history_details_attributes.push(itemPO);
      }
    });
    reqPayload.purchase_order.history_details =
      reqPayload.purchase_order.history_details_attributes;
  } else {
    reqPayload = {
      ingredient_purchase_order: {
        outlet_id: data.outlet,
        note: data.note,
        status: 'Created',
        supplier_id: data.supplierName === '' ? 0 : parseInt(data.supplierName),
        total: 0,
        ingredient_history_details: [],
        ingredient_history_details_attributes: [],
      },
    };
    data.itemPurchase.forEach(ingredient => {
      // Front End must process the order and unitcost using parsefloat or parseint since the backend return the value as a string
      const order = parseFloat(ingredient.order);
      const unitCost = parseInt(ingredient.unitcost);
      const inStock = parseFloat(ingredient.instock);
      reqPayload.ingredient_purchase_order.total += multiplyFloatingPointRounding(
        order,
        unitCost
      );
      if (Math.abs(order) > 0.00000001) {
        const itemPO = {
          beginning_stock: inStock,
          end_stock: inStock + order,
          ingredient_category_id: ingredient.category_id,
          ingredient_category_name: ingredient.category_name,
          ingredient_id: ingredient.item_id,
          ingredient_name: ingredient.item_name,
          unit_id: ingredient.item_var_id,
          unit_name: ingredient.item_var_name,
          unit_price: unitCost,
          total_price: multiplyFloatingPointRounding(order, unitCost),
          quantity: order,
        };
        reqPayload.ingredient_purchase_order.ingredient_history_details_attributes.push(
          itemPO
        );
      }
    });
    reqPayload.ingredient_purchase_order.ingredient_history_details =
      reqPayload.ingredient_purchase_order.ingredient_history_details_attributes;
  }
  return reqPayload;
}

export function* createPO(request) {
  const { namespace, data, date } = request.payload;
  let reqPayload = {};
  reqPayload = populateDataPO(namespace, reqPayload, data);
  yield put(actInvPO.setDisabledCreateAndFulfillButton(true));
  try {
    yield put(act.showProgressBar());
    let createResult;
    namespace === NAMESPACE_INGREDIENTS
      ? (createResult = yield call(apiIngInv.postPurchaseOrder, reqPayload))
      : (createResult = yield call(apiInvPO.postPurchaseOrder, reqPayload));
    if (createResult.data.error) {
      yield put(actNotif.error(createResult.data.error));
    } else {
      yield put(actNotif.success('Purchase order has been created'));
    }
    if (!moment().isBetween(date.startDate, date.endDate, 'day', '[]')) {
      yield call(apiUpdateFilteredDate.updateFilteredDate, {
        from: moment().format('D/M/YYYY'),
        to: moment().format('D/M/YYYY'),
      });
    }
    yield put(actInvPO.pageRequest());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actInvPO.setDisabledCreateAndFulfillButton(false));
    yield put(act.hideProgressBar());
  }
}

export function* createFulfilledPO(request) {
  const { namespace, data, date } = request.payload;
  let reqPayload = {};
  reqPayload = populateDataPO(namespace, reqPayload, data);
  try {
    yield put(act.showProgressBar());
    yield put(actInvPO.setDisabledCreateAndFulfillButton(true));
    let createResult;
    namespace === NAMESPACE_INGREDIENTS
      ? (createResult = yield call(apiIngInv.createAndfullfilled, reqPayload))
      : (createResult = yield call(apiInvPO.createAndfullfilled, reqPayload));
    if (createResult.data.error) {
      yield put(actNotif.error(createResult.data.error));
    } else {
      yield put(
        actNotif.success(
          'Purchase order has been created and mark as fulfilled'
        )
      );
    }
    yield call(emptyForm);
    if (!moment().isBetween(date.startDate, date.endDate, 'day', '[]')) {
      yield call(apiUpdateFilteredDate.updateFilteredDate, {
        from: moment().format('D/M/YYYY'),
        to: moment().format('D/M/YYYY'),
      });
    }
    yield put(actInvPO.pageRequest());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
    yield put(actInvPO.setDisabledCreateAndFulfillButton(false));
  }
}

export function* editPO(request) {
  const { namespace, data } = request.payload;
  let reqPayload = {};
  yield put(actInvPO.setDisabledCreateAndFulfillButton(true));
  if (namespace === NAMESPACE_ITEMS) {
    const purchaseO = yield call(apiInvPO.getEditDataPO, data.id);
    reqPayload = {
      purchase_order: purchaseO.data,
    };
    reqPayload.purchase_order.total = 0;
    reqPayload.purchase_order.note = data.note;
    reqPayload.purchase_order.status = 'Created';
    reqPayload.purchase_order.history_details_attributes = [];
    data.itemPurchase.forEach(item => {
      reqPayload.purchase_order.total +=
        parseInt(item.order) * parseInt(item.unitcost);
      if (parseInt(item.order) > 0) {
        let itemPO = {};
        if (item.item_var_name !== '') {
          itemPO = {
            beginning_stock: parseInt(item.instock),
            end_stock: parseInt(item.instock) + parseInt(item.order),
            item_id: item.item_id,
            item_name: item.item_name,
            item_variant_id: item.item_var_id,
            item_variant_name: item.item_var_name,
            price: item.unitcost,
            quantity: item.order,
          };
        } else {
          itemPO = {
            beginning_stock: parseInt(item.instock),
            end_stock: parseInt(item.instock) + parseInt(item.order),
            item_id: item.item_id,
            item_name: item.item_name,
            item_variant_id: item.item_var_id,
            item_variant_name: item.item_name,
            price: item.unitcost,
            quantity: item.order,
          };
        }
        reqPayload.purchase_order.history_details_attributes.push(itemPO);
      }
    });
    reqPayload.purchase_order.history_details =
      reqPayload.purchase_order.history_details_attributes;
  } else {
    const purchaseO = yield call(apiIngInv.getEditDataPO, data.id);
    reqPayload = {
      ingredient_purchase_order: purchaseO.data,
    };
    reqPayload.ingredient_purchase_order.total = 0;
    reqPayload.ingredient_purchase_order.note = data.note;
    reqPayload.ingredient_purchase_order.status = 'Created';
    reqPayload.ingredient_purchase_order.ingredient_history_details_attributes = [];
    data.itemPurchase.forEach(ingredient => {
      const order = parseFloat(ingredient.order);
      const unitCost = parseInt(ingredient.unitcost);
      const inStock = parseFloat(ingredient.instock);
      reqPayload.ingredient_purchase_order.total += multiplyFloatingPointRounding(
        order,
        unitCost
      );
      if (Math.abs(order) > 0.00000001) {
        const ingredientPO = {
          beginning_stock: inStock,
          end_stock: inStock + order,
          ingredient_category_id: ingredient.category_id,
          ingredient_category_name: ingredient.category_name,
          ingredient_id: ingredient.item_id,
          ingredient_name: ingredient.item_name,
          unit_id: ingredient.item_var_id,
          unit_name: ingredient.item_var_name,
          unit_price: unitCost,
          total_price: multiplyFloatingPointRounding(order, unitCost),
          quantity: order,
        };
        reqPayload.ingredient_purchase_order.ingredient_history_details_attributes.push(
          ingredientPO
        );
      }
    });
    reqPayload.ingredient_purchase_order.ingredient_history_details =
      reqPayload.ingredient_purchase_order.ingredient_history_details_attributes;
  }
  try {
    yield put(act.showProgressBar());
    let editResult;
    namespace === NAMESPACE_INGREDIENTS
      ? (editResult = yield call(
          apiIngInv.updateDataPO,
          reqPayload.ingredient_purchase_order.id,
          reqPayload
        ))
      : (editResult = yield call(
          apiInvPO.updateDataPO,
          reqPayload.purchase_order.id,
          reqPayload
        ));
    if (editResult.data.error) {
      yield put(actNotif.error(editResult.data.error));
    } else {
      yield put(actNotif.success('Purchase order has been updated'));
    }
    yield put(actInvPO.setPurchaseOrderDetail(null));
    yield put(actInvPO.pageRequest());
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(actInvPO.setDisabledCreateAndFulfillButton(false));
    yield put(act.hideProgressBar());
  }
}

export function* onClickEdit(request) {
  const {
    payload: { purchaseOrder },
  } = request;
  try {
    yield put(act.showProgressBar());
    if (purchaseOrder.ingredient_history_details) {
      const itemVars = purchaseOrder.ingredient_history_details.map(iv => {
        return {
          item_var_name: iv.unit_name,
          item_var_id: iv.unit_id,
          instock: iv.beginning_stock,
          order: `${iv.quantity}`,
          unitcost: `${iv.unit_price}`,
          item_name: iv.ingredient_name,
          item_id: iv.ingredient_id,
          is_item: false,
          category_id: iv.ingredient_category_id,
          category_name: iv.ingredient_category_name,
          total: rupiah(iv.quantity * iv.unit_price),
        };
      });
      yield put(
        initialize('purchaseOrder', {
          outlet: purchaseOrder.outlet.id,
          supplierName: purchaseOrder.supplier_id,
          note: purchaseOrder.note,
          itemPurchase: itemVars,
          id: purchaseOrder.id,
        })
      );
      yield put(actInvPO.openRightColumnAsForm());
    } else {
      const itemVars = purchaseOrder.history_details.map(iv => {
        return {
          item_var_name: iv.item_variant_name,
          item_var_id: iv.item_variant_id,
          instock: iv.beginning_stock,
          order: `${iv.quantity}`,
          unitcost: `${iv.price}`,
          item_name: iv.item_name,
          item_id: iv.item_id,
          is_item: iv.is_item,
          total: rupiah(iv.quantity * iv.price),
        };
      });

      yield put(
        initialize('purchaseOrder', {
          outlet: purchaseOrder.outlet.id,
          supplierName: purchaseOrder.supplier_id,
          note: purchaseOrder.note,
          itemPurchase: itemVars,
          id: purchaseOrder.id,
        })
      );
      yield put(actInvPO.openRightColumnAsForm());
    }
  } catch (error) {
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onSuccessImport() {
  yield call(apiUpdateFilteredDate.updateFilteredDate, {
    from: moment().format('D/M/YYYY'),
    to: moment().format('D/M/YYYY'),
  });
  yield put(actInvPO.hideImportModal());
  yield put(actInvPO.closeRightColumn());
  yield put(actNotif.success('PO successfully imported'));
  yield put(actInvPO.pageRequest());
}

export default function* saga() {
  yield takeLatest(INVENTORY_PURCHASE_ORDER_PAGE_REQUEST, pageRequest);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_PURCHASE_ORDER_REQUEST,
    purchaseOrderRequest
  );
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_IDS,
    onChangeOutletIds
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CHANGE_DATE, onChangeDate);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_ON_CHANGE_NAMESPACE,
    onChangeNamespace
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CHANGE_STATUS, onChangeStatus);
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CHANGE_KEYWORD, onChangeKeyword);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_EXPORT_PURCHASE_ORDER,
    exportPurchaseOrder
  );
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_EXPORT_FAILED,
    exportPurchaseOrderFailed
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CLICK_ROW, onClickRow);
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CLICK_DONE, onClickDone);
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CLICK_CANCEL, onClickCancel);
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CLICK_PRINT, onClickPrint);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_ON_CLICK_CREATE_PO,
    onClickCreatePO
  );
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_UPDATE_PURCHASE_ORDER,
    updatePurchaseOrder
  );
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_GET_ITEMS_FROM_API,
    getItemsfromAPI
  );
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_SET_MODAL_DATA_FORM,
    setModalItemForm
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ADD_ITEM_TO_FORM, addItemToForm);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_ON_CANCEL_MODAL_ADD_ITEM,
    onCancelModalAddItem
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_CREATE_PURCHASE_ORDER, createPO);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_CREATE_AND_FULFILLED_PURCHASE_ORDER,
    createFulfilledPO
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_EDIT_PURCHASE_ORDER, editPO);
  yield takeLatest(
    INVENTORY_PURCHASE_ORDER_ON_CHANGE_OUTLET_FORM,
    onchangeOutletForm
  );
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_CLICK_EDIT, onClickEdit);
  yield takeLatest(INVENTORY_PURCHASE_ORDER_ON_SUCCESS_IMPORT, onSuccessImport);
  yield takeEvery(
    INVENTORY_PURCHASE_ORDER_ON_CLICK_RESEND_EMAIL,
    onClickResendEmail
  );
}

function multiplyFloatingPointRounding(a, b, precision) {
  if (precision === undefined) {
    precision = 0;
  }
  const factor = Math.pow(10, precision);
  return Math.round(a * b * factor) / factor;
}
